import type { LoaderFunctionArgs } from '@remix-run/node';
import { getMoodBoardList } from '@modules-rocco/design-board/api/get-mood-board-list.server';

export const ACTION_GET_MOOD_BOARD_LIST = '/actions/get-mood-board-list';

export const loader = async ({ request, context }: LoaderFunctionArgs) => {
    const url = new URL(request.url);

    return await getMoodBoardList(
        {
            limit: parseInt(url.searchParams.get('limit') || '100'),
            offset: parseInt(url.searchParams.get('offset') || '0'),
        },
        context
    );
};
